export function contactedThisMonth(timestamp: string | null | undefined, now = new Date()): boolean {
  if (!timestamp) return false;
  const contact = new Date(timestamp);
  return contact.getFullYear() === now.getFullYear() && contact.getMonth() === now.getMonth();
}
